var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "basic-form-container" }, [
    _c(
      "div",
      { staticClass: "left-section" },
      [
        _c(
          "el-form-item",
          { attrs: { label: "店面名称", prop: "storeName" } },
          [
            _c("el-input", {
              model: {
                value: _vm.formData.storeName,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "storeName", $$v)
                },
                expression: "formData.storeName",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        false
          ? _c(
              "el-form-item",
              { attrs: { label: "地图标识", prop: "mapMark" } },
              [
                _c("el-input", {
                  model: {
                    value: _vm.formData.mapId,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "mapId", $$v)
                    },
                    expression: "formData.mapId",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("el-form-item", { attrs: { label: "经纬度" } }, [
          _c(
            "div",
            { staticClass: "coordinate-container" },
            [
              _c("el-input", {
                attrs: { placeholder: "纬度" },
                scopedSlots: _vm._u([
                  {
                    key: "prepend",
                    fn: function () {
                      return [_vm._v("lat")]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.formData.lat,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "lat", $$v)
                  },
                  expression: "formData.lat",
                },
              }),
              _vm._v(" "),
              _c("el-input", {
                attrs: { placeholder: "经度" },
                scopedSlots: _vm._u([
                  {
                    key: "prepend",
                    fn: function () {
                      return [_vm._v("lng")]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.formData.lng,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "lng", $$v)
                  },
                  expression: "formData.lng",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "el-form-item",
          { attrs: { label: "联系人", prop: "linkName" } },
          [
            _c("el-input", {
              model: {
                value: _vm.formData.linkName,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "linkName", $$v)
                },
                expression: "formData.linkName",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-form-item",
          { attrs: { label: "紧急联系人", prop: "storePhone" } },
          [
            _c("el-input", {
              model: {
                value: _vm.formData.storePhone,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "storePhone", $$v)
                },
                expression: "formData.storePhone",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-form-item",
          { attrs: { label: "门店座机号", prop: "storeMobile" } },
          [
            _c("el-input", {
              model: {
                value: _vm.formData.storeMobile,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "storeMobile", $$v)
                },
                expression: "formData.storeMobile",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-form-item",
          { attrs: { label: "店铺地址", prop: "storeAddress" } },
          [
            _c("el-input", {
              model: {
                value: _vm.formData.storeAddress,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "storeAddress", $$v)
                },
                expression: "formData.storeAddress",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-form-item",
          { attrs: { label: "供货商", prop: "suppliersId" } },
          [
            _c(
              "el-select",
              {
                staticClass: "region-select",
                attrs: { placeholder: "请选择品牌" },
                model: {
                  value: _vm.formData.suppliersId,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "suppliersId", $$v)
                  },
                  expression: "formData.suppliersId",
                },
              },
              _vm._l(_vm.supplierOptions, function (supplier) {
                return _c("el-option", {
                  key: supplier.id,
                  attrs: { label: supplier.brandName, value: supplier.id },
                })
              }),
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-form-item",
          { attrs: { label: "门店地区" } },
          [
            _c(
              "el-select",
              {
                staticStyle: { width: "200px" },
                attrs: { placeholder: "请选择门店地区" },
                model: {
                  value: _vm.formData.areaId,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "areaId", $$v)
                  },
                  expression: "formData.areaId",
                },
              },
              _vm._l(_vm.areaOptions, function (area) {
                return _c("el-option", {
                  key: area.id,
                  attrs: { label: area.areaName, value: area.id },
                })
              }),
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("el-form-item", { attrs: { label: "店面地区" } }, [
          _c(
            "div",
            { staticStyle: { display: "flex", gap: "10px" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "region-select",
                  attrs: { placeholder: "请选择省份" },
                  on: { change: _vm.handleProvinceChange },
                  model: {
                    value: _vm.formData.provinceId,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "provinceId", $$v)
                    },
                    expression: "formData.provinceId",
                  },
                },
                _vm._l(_vm.regionOptions, function (province) {
                  return _c("el-option", {
                    key: province.regionId,
                    attrs: {
                      label: province.regionName,
                      value: province.regionId,
                    },
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticClass: "region-select",
                  attrs: { placeholder: "请选择城市" },
                  model: {
                    value: _vm.formData.cityId,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "cityId", $$v)
                    },
                    expression: "formData.cityId",
                  },
                },
                _vm._l(_vm.cityOptions, function (city) {
                  return _c("el-option", {
                    key: city.regionId,
                    attrs: { label: city.regionName, value: city.regionId },
                  })
                }),
                1
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        false
          ? _c(
              "el-form-item",
              { attrs: { label: "是否覆盖" } },
              [
                _c("el-switch", {
                  staticClass: "green-switch",
                  attrs: { "active-value": 1, "inactive-value": 0 },
                  model: {
                    value: _vm.formData.fullCoverage,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "fullCoverage", $$v)
                    },
                    expression: "formData.fullCoverage",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "el-form-item",
          {
            attrs: { label: "福利社背景" },
            scopedSlots: _vm._u([
              {
                key: "label",
                fn: function () {
                  return [
                    _c("div", [
                      _c("div", [_vm._v("福利社背景")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "image-tip" }, [
                        _vm._v("(750px * 1624px)"),
                      ]),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          },
          [
            _vm._v(" "),
            _c(
              "el-upload",
              {
                attrs: {
                  action: "#",
                  "list-type": "picture-card",
                  limit: 1,
                  "file-list": _vm.welfareCodeImages,
                  "on-exceed": _vm.handleExceed,
                  "before-upload": _vm.beforeImageUpload,
                  "on-preview": _vm.handlePictureCardPreview,
                  "on-remove": _vm.handleWelfareRemove,
                  "on-change": _vm.handleWelfareChange,
                },
              },
              [_c("i", { staticClass: "el-icon-plus" })]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-form-item",
          {
            attrs: { label: "门店卡片背景" },
            scopedSlots: _vm._u([
              {
                key: "label",
                fn: function () {
                  return [
                    _c("div", [
                      _c("div", [_vm._v("门店卡片背景")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "image-tip" }, [
                        _vm._v("(750px * 400px)"),
                      ]),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          },
          [
            _vm._v(" "),
            _c(
              "el-upload",
              {
                attrs: {
                  action: "#",
                  "list-type": "picture-card",
                  limit: 1,
                  "file-list": _vm.cardBackgroundImages,
                  "on-exceed": _vm.handleExceed,
                  "before-upload": _vm.beforeImageUpload,
                  "on-preview": _vm.handlePictureCardPreview,
                  "on-remove": _vm.handleCardBackgroundRemove,
                  "on-change": _vm.handleCardBackgroundChange,
                },
              },
              [_c("i", { staticClass: "el-icon-plus" })]
            ),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "right-section" },
      [
        _c(
          "el-form-item",
          {
            attrs: { label: "企业二维码" },
            scopedSlots: _vm._u([
              {
                key: "label",
                fn: function () {
                  return [
                    _c("div", [
                      _c("div", [_vm._v("企业二维码")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "image-tip" }, [
                        _vm._v("(702px * 320px)"),
                      ]),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          },
          [
            _vm._v(" "),
            _c(
              "el-upload",
              {
                attrs: {
                  action: "#",
                  "list-type": "picture-card",
                  limit: 1,
                  "file-list": _vm.qrCodeImages,
                  "on-exceed": _vm.handleExceed,
                  "before-upload": _vm.beforeImageUpload,
                  "on-preview": _vm.handlePictureCardPreview,
                  "on-remove": _vm.handleQrRemove,
                  "on-change": _vm.handleQrChange,
                },
              },
              [_c("i", { staticClass: "el-icon-plus" })]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-form-item",
          {
            attrs: { label: "线下企业二维码" },
            scopedSlots: _vm._u([
              {
                key: "label",
                fn: function () {
                  return [
                    _c("div", [
                      _c("div", [_vm._v("线下企业二维码")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "image-tip" }, [
                        _vm._v("(702px * 320px)"),
                      ]),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          },
          [
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "offline-qr-upload" },
              [
                _c(
                  "el-upload",
                  {
                    attrs: {
                      action: "#",
                      "list-type": "picture-card",
                      limit: 1,
                      "file-list": _vm.offlineQrCodeImages,
                      "on-exceed": _vm.handleExceed,
                      "before-upload": _vm.beforeImageUpload,
                      "on-preview": _vm.handlePictureCardPreview,
                      "on-remove": _vm.handleOfflineQrRemove,
                      "on-change": _vm.handleOfflineQrChange,
                    },
                  },
                  [_c("i", { staticClass: "el-icon-plus" })]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "offline-qr-tip" }, [
                  _vm._v(
                    "生成路径必须包含关键参数 mine，例如：pages/user/wechat/index?page=mine"
                  ),
                ]),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "el-form-item",
          {
            staticClass: "qr-bg-upload-item",
            attrs: { label: "二维码背景图" },
            scopedSlots: _vm._u([
              {
                key: "label",
                fn: function () {
                  return [
                    _c("div", [
                      _c("div", [_vm._v("二维码背景图")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "image-tip" }, [
                        _vm._v("(1053px * 240px)"),
                      ]),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          },
          [
            _vm._v(" "),
            _c(
              "el-upload",
              {
                attrs: {
                  action: "#",
                  "list-type": "picture-card",
                  limit: 1,
                  "file-list": _vm.qrBgImages,
                  "on-exceed": _vm.handleExceed,
                  "before-upload": _vm.beforeImageUpload,
                  "on-preview": _vm.handlePictureCardPreview,
                  "on-remove": _vm.handleQrBgRemove,
                  "on-change": _vm.handleQrBgChange,
                },
              },
              [_c("i", { staticClass: "el-icon-plus" })]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-form-item",
          { attrs: { label: "小程序展示" } },
          [
            _c(
              "el-checkbox",
              {
                attrs: { "true-label": 1, "false-label": 0 },
                model: {
                  value: _vm.formData.isStop,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "isStop", $$v)
                  },
                  expression: "formData.isStop",
                },
              },
              [_vm._v("微信小程序")]
            ),
            _vm._v(" "),
            _c(
              "el-checkbox",
              {
                attrs: { "true-label": 1, "false-label": 0 },
                model: {
                  value: _vm.formData.isStopAli,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "isStopAli", $$v)
                  },
                  expression: "formData.isStopAli",
                },
              },
              [_vm._v("支付宝小程序")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-form-item",
          { attrs: { label: "营业状态" } },
          [
            _c(
              "el-radio-group",
              {
                model: {
                  value: _vm.formData.openStatus,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "openStatus", $$v)
                  },
                  expression: "formData.openStatus",
                },
              },
              [
                _c("el-radio", { attrs: { label: 0 } }, [_vm._v("歇业中")]),
                _vm._v(" "),
                _c("el-radio", { attrs: { label: 1 } }, [_vm._v("正常营业")]),
                _vm._v(" "),
                _c("el-radio", { attrs: { label: 2 } }, [_vm._v("即将开业")]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-form-item",
          {
            attrs: { label: "订单失效时间" },
            scopedSlots: _vm._u([
              {
                key: "label",
                fn: function () {
                  return [
                    _c("div", [
                      _c("div", [_vm._v("订单失效时间")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "image-tip" }, [
                        _vm._v("（分钟）"),
                      ]),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          },
          [
            _vm._v(" "),
            _c("el-input-number", {
              staticStyle: { width: "200px" },
              attrs: { min: 1, max: 120, "controls-position": "right" },
              model: {
                value: _vm.formData.orderExpireTime,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "orderExpireTime", $$v)
                },
                expression: "formData.orderExpireTime",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-form-item",
          { attrs: { label: "门店活动标题", prop: "activityTitle" } },
          [
            _c("el-input", {
              staticStyle: { width: "300px" },
              attrs: { placeholder: "请输入门店活动标题", maxlength: "100" },
              model: {
                value: _vm.formData.activityTitle,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "activityTitle", $$v)
                },
                expression: "formData.activityTitle",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-form-item",
          { attrs: { label: "是否新店" } },
          [
            _c(
              "el-radio-group",
              {
                model: {
                  value: _vm.formData.isNewStore,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "isNewStore", $$v)
                  },
                  expression: "formData.isNewStore",
                },
              },
              [
                _c("el-radio", { attrs: { label: 0 } }, [_vm._v("否")]),
                _vm._v(" "),
                _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-form-item",
          { attrs: { label: "店铺描述" } },
          [
            _c("el-input", {
              attrs: { type: "textarea", rows: 4 },
              model: {
                value: _vm.formData.storeDesc,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "storeDesc", $$v)
                },
                expression: "formData.storeDesc",
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }